import React from "react";
import checkMarkIcon from "../../assets/images/checkmark_check_tick-green_bg.svg";

const SuccessModal = ({ isSuccess, successMessage, onClose }) => {
  if (!isSuccess) return null;

  return (
    <div
      className="modal upgrade-plan cancel-subscription-modal updated-successfully-modal canceled-successfully show fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="false"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="upgrade-plan-content text-center">
            <img
              src={checkMarkIcon}
              className="img-fluid success-icon"
              alt="Success"
              width="60"
              height="60"
            />
            <span className="loading-msg d-block success-msg">
              {successMessage}
            </span>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="modal-btn confirm-btn ok-btn"
              onClick={onClose}
            >
              OKAY
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
